import { LicenseManager } from 'ag-grid-enterprise';

export const setAGGridLicense = (config) => {
  if (typeof window !== 'undefined') {
    LicenseManager.setLicenseKey(config.AG_GRID_LICENSE);
  }
};
